import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MastersService } from '../../../shared/services/masters/masters.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Helpers } from '../../../helpers';
import { DriverService } from '../../../shared/services/driver/driver.service';
import { OrdersService } from '../../../shared/services/orders/orders.service';
import { number } from '@amcharts/amcharts4/core';

@Component({
  selector: 'app-editaddress',
  templateUrl: './editaddress.component.html',
  styleUrls: ['./editaddress.component.scss']
})
export class EditaddressComponent implements OnInit, OnChanges {

  @Input() data: any;
  @Input() isMobileView: any;
  @Output() modifiedValueOutput = new EventEmitter<any>();
  @Output() dataViewCatch = new EventEmitter<any>();
  @Output() onSave = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();
  @Output() onCloseEvent = new EventEmitter<any>();
  @Input() listOfField = [];
  @Input() TypeofService: any;
  modalRef: any;
  FloorNo: any;
  UnitNo: any;
  isFormSubmit: boolean;
  Address: any;
  Landmark: any;
  PostalCode = {
    lable: "Postal Code",
    placeholder: "Enter Postal Code",
    dataField: 'PostalCode',
    formControlName: 'PostalCode',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    // isValueBind: true,
    isSearch: false
  };
  State = {
    lable: "State",
    placeholder: "Select State",
    dataField: 'State',
    formControlName: 'State',
    typeOfField: 'dropdown',
    // isValueBind: true,
    isSearch: false
  };
  City = {
    lable: "City",
    placeholder: "Select City",
    dataField: 'City',
    formControlName: 'City',
    typeOfField: 'dropdown',
    isSearchByApi: true,
    // isValueBind: true,
    isSearch: false
  };
  Country: any;
  IsActive: any;
  MobileNo: any;
  Email: any;
  ContactPerson: any;
  static that: EditaddressComponent;

  constructor(
    private modalService: NgbModal,
    private master: MastersService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private driverService: DriverService,
    private orderService: OrdersService
  ) { EditaddressComponent.that = this; }

  ngOnInit() {
    this.initializeform();
    // this.initiateFrom()
    this.getDropdownListV2('%%', this.State);
    this.getDropdownListV2('%%', this.Country);
  }
  open(content, isNew = false) {
    isNew ? this.data = {} : null
    this.modalRef = this.modalService.open(content);
  }

  initializeform() {
    this.FloorNo = {
      lable: "Floor No",
      placeholder: "Enter Floor No",
      dataField: 'FloorNo',
      formControlName: 'FloorNo',
    };
    this.UnitNo = {
      lable: "Unit No",
      placeholder: "Enter Unit No",
      dataField: 'UnitNo',
      formControlName: 'UnitNo',
      isValueBind: true
    };
    this.Address = {
      lable: "Address",
      placeholder: "Enter Address",
      dataField: 'Address',
      formControlName: 'Address',
    };
    this.Landmark = {
      lable: "Landmark",
      placeholder: "Enter Landmark",
      dataField: 'Landmark',
      formControlName: 'Landmark',
    };
    this.Country = {
      lable: "Country",
      placeholder: "Select Country",
      dataField: 'Country',
      formControlName: 'Country',
    };
    this.IsActive = {
      dataField: 'IsActive',
      formControlName: 'IsActive',
    };
    this.ContactPerson = {
      lable: "Contact Person",
      placeholder: "Enter Contact Person",
      dataField: 'ContactPerson',
      formControlName: 'ContactPerson',
    };
    this.MobileNo = {
      lable: "Mobile No",
      placeholder: "Enter Mobile No",
      dataField: 'MobileNo',
      formControlName: 'MobileNo',
      // onlyNumber: true,
      type:"number"
    };
    this.Email = {
      lable: "Email",
      placeholder: "Enter Email",
      dataField: 'Email',
      formControlName: 'Email'
    };
  }

  assignFieldDetails(dropdownList) {
    this.UnitNo = {
      ...this.UnitNo, dropdownList: dropdownList[0]
    };

  }

  ngOnChanges(changes: SimpleChanges): void {
    const data: SimpleChange = changes.data && changes.data.currentValue;
    if (data && this.data.PostalCode) {
      this.getDropdownListV2(this.data.PostalCode, this.PostalCode);
    }
    if (data && this.data.City) {
      this.getDropdownListV2(this.data.City, this.City, true);
    }
  }

  initiateFrom() {
    const arrayOfApiList = [];
    if (
      this.master.bodyTypeList.length) {
      this.assignFieldDetails([
        this.master.bodyTypeList
      ])
      return;
    }
    Helpers.setLoading(true);
    Promise.all([
      EditaddressComponent.that.master.GetBodyType(),

    ])
      .then((results) => {
        Helpers.setLoading(false);
        EditaddressComponent.that.assignFieldDetails(results);
      })
      .catch((error) => {
        console.error('Error initializing data:', error);
      });
  }

  getDropdownListV2(value, data, isfromAddPage: boolean = false) {
    if (data.dataField === 'PostalCode') {
      this.searchStatusOnField(data, true);
      this.driverService.getAdressDetailByPostcode(value).then(res => {
        this.findObjectOfTheFieldV2(data, res);
      }).catch(error => {
        this.searchStatusOnField(data, false)
      })
    }
    if (data.dataField === 'State') {
      this.searchStatusOnField(data, true);
      this.orderService.getCountryDetailByPostcode(value, 'State', null).then(res => {
        this.findObjectOfTheFieldV2(data, res);
      }).catch(error => {
        this.searchStatusOnField(data, false)
      })
    }
    if (data.dataField === 'City') {

      this.searchStatusOnField(data, true);
      this.orderService.getCountryDetailByPostcode(value, 'City', null).then(res => {
        this.findObjectOfTheFieldV2(data, res, isfromAddPage);
      }).catch(error => {
        this.searchStatusOnField(data, false)
      })
    }
    if (data.dataField === 'Country') {
      this.searchStatusOnField(data, true);
      this.orderService.getCountryDetailByPostcode(value, 'Country', null).then(res => {
        this.findObjectOfTheFieldV2(data, res);
      }).catch(error => {
        this.searchStatusOnField(data, false)
      })
    }
  }

  findObjectOfTheFieldV2(data, dropdownList, isfromAddPage: boolean = false) {
    var listarr = [];
    if (isfromAddPage)
      listarr.push(dropdownList[0]);
    else
      listarr = dropdownList;

    data.dropdownList = listarr;
    data.isSearch = false;
    if (data.dataField) {
      data.isReadOnly = false
    }
  }

  searchStatusOnField(data, Status) {
    data.isSearch = Status;
  }

  getChangedValue(value, dataFeild) {
    if (dataFeild == 'PostalCode') {
      this.data[dataFeild] = value.value;
      this.data.City = value.CityName;
      this.data.Country = value.CountryName;
      this.data.State = value.StateName;

      var namePostal = value.value;
      var nameCity = value.CityName;
      var nameCountry = value.CountryName;
      var nameState = value.StateName;

      var dataFeildP = 'PostalCode';
      var dataFeildC = 'City';
      var dataFeildS = 'State';
      var dataFeildCn = 'Country';

      this.modifiedValueOutput.emit({ namePostal, dataFeildP });
      this.modifiedValueOutput.emit({ nameCity, dataFeildC });
      this.modifiedValueOutput.emit({ nameCountry, dataFeildCn });
      this.modifiedValueOutput.emit({ nameState, dataFeildS });

    } else if (dataFeild == 'City' || dataFeild == 'State' || dataFeild == 'Country') {
      this.data[dataFeild] = value.name;
      var name = value.name;
      this.modifiedValueOutput.emit({ name, dataFeild });
    } else {
      this.data[dataFeild] = value;
      this.modifiedValueOutput.emit({ value, dataFeild });
    }
  }

  close() {
    this.onCloseEvent.emit();
  }

  changeActiveStatus(status: any) {
    this.data.IsActive = status
  }

  isFormInValid() {
    return this.listOfField.some(item => item.some(x => x.isRequired && !this.data[x.dataField]));
  }

  onSaveBtnClick() {
    this.isFormSubmit = true

    if (this.isFormInValid()) {
      this.toastr.error(this.translate.instant("DriverDetailsById.RequiredError"), "error");
      return;
    }
    if (this.data && this.data.MobileNo && this.data.MobileNo.length != 10) {
      this.toastr.warning('Mobile no should have 10 digits', 'warning');
      return;
    }
    var data = this.data;
    var type = this.TypeofService;
    this.onSave.emit({ data, type });
    this.close()
  }

  onclose() {
    this.onClose.emit();
  }

}
